import { orchestrator } from 'satcheljs';
import { onInitialTableLoadComplete } from 'owa-mail-triage-table-utils';
import { getCanTableLoadMore } from '../utils/getCanTableLoadMore';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import { lazyLoadMoreInTable } from '../index';

orchestrator(onInitialTableLoadComplete, actionMessage => {
    const tableView = actionMessage.tableView;

    // Loading of more rows should be done asynchronously
    // Avoid loading more rows if we have just performed a JumpTo (loadedStartIndex > 0)
    // We must check getCanTableLoadMore and loadedStartIndex again after import
    if (tableView && getCanTableLoadMore(tableView) && tableView.loadedStartIndex === 0) {
        lazyLoadMoreInTable.import().then(loadMoreInTable => {
            if (getCanTableLoadMore(tableView) && tableView.loadedStartIndex === 0) {
                loadMoreInTable(tableView);
            }
        });
    }
});
